import { useEffect } from "react";

import { getFingerprintHeader } from "@shared/helpers/getFingerprintHeader/getFingerprintHeader";

const PreloadFingerprint = () => {
  useEffect(() => {
    getFingerprintHeader().catch(() => {
      // ignore errors
    });
  }, []);

  return null;
};

export { PreloadFingerprint };
